'use client';

import React from 'react';

import usePathControl from '@components/views/hooks/usePathControl';

const ClientWrapper = ({ children }: { children: React.ReactNode }) => {
  usePathControl(); // Use your hook here

  return <>{children}</>; // Render the children
};

export default ClientWrapper;
